import React from 'react';
import ClickableIcon from 'jitsi/base/ui/components/web/ClickableIcon';
export const IISightIcon = (props) => {
    return React.createElement(ClickableIcon, { colorInClass: true, ...props });
};
